module.exports = __webpack_public_path__ + "img/编组 2.c92ab45c.png";